import { combineEpics } from 'redux-observable';
import { NotificationActionTypes, FetchNotifications, UpdateWeeklyProgressReportSubscription, UpdateMonthlyMarketingReportSubscription, UpdateCalendarNotification, UpdateSuccessNotification, UpdateProjectsNotification, UpdateLeadRevisitNotification, ResendMonthlyMarketingReport, ResendWeeklyProgressReport, SendMonthlyMarketingReport, SendWeeklyProgressReport } from '../actions/NotificationActions';
import { getFetchNotificationsRequestStatus, getUpdateWeeklyProgressReportSubscriptionRequestStatus, getUpdateMonthlyMarketingReportSubscriptionRequestStatus, getUpdateCalendarNotificationRequestStatus, getUpdateSuccessNotificationRequestStatus, getUpdateProjectsNotificationRequestStatus, getUpdateLeadRevisitNotificationRequestStatus, getResendMonthlyMarketingReportRequestStatus, getResendWeeklyProgressReportRequestStatus, getSendMonthlyMarketingReportRequestStatus, getSendWeeklyProgressReportRequestStatus } from '../selectors/RequestStatusSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import NotificationsAPI from '../api/NotificationsAPI';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchNotifications = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.getNotifications,
  initiatingActionType: NotificationActionTypes.LOAD_NOTIFICATIONS,
  requestStatusSelector: getFetchNotificationsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.FAILED],
  requestActions: FetchNotifications
}));
const updateWeeklyProgressReportSubscription = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.toggleEmailSubscription,
  initiatingActionType: NotificationActionTypes.UPDATE_WEEKLY_PROGRESS_REPORT_SUBSCRIPTION,
  requestStatusSelector: getUpdateWeeklyProgressReportSubscriptionRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateWeeklyProgressReportSubscription
}));
const updateMonthlyMarketingReportSubscription = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.toggleEmailSubscription,
  initiatingActionType: NotificationActionTypes.UPDATE_MONTHLY_MARKETING_REPORT_SUBSCRIPTION,
  requestStatusSelector: getUpdateMonthlyMarketingReportSubscriptionRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateMonthlyMarketingReportSubscription
}));
const updateCalendarNotification = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.toggleEmailSubscription,
  initiatingActionType: NotificationActionTypes.UPDATE_CALENDAR_NOTIFICATION,
  requestStatusSelector: getUpdateCalendarNotificationRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateCalendarNotification
}));
const updateSuccessNotification = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.toggleEmailSubscription,
  initiatingActionType: NotificationActionTypes.UPDATE_SUCCESS_NOTIFICATION,
  requestStatusSelector: getUpdateSuccessNotificationRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateSuccessNotification
}));
const updateProjectsNotification = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.toggleEmailSubscription,
  initiatingActionType: NotificationActionTypes.UPDATE_PROJECTS_NOTIFICATION,
  requestStatusSelector: getUpdateProjectsNotificationRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateProjectsNotification
}));
const updateLeadRevisitNotification = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.setLeadRevisitSetting,
  initiatingActionType: NotificationActionTypes.UPDATE_LEAD_REVISIT_NOTIFICATION,
  requestStatusSelector: getUpdateLeadRevisitNotificationRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateLeadRevisitNotification
}));
const resendMonthlyMarketingReport = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.resendEmail,
  initiatingActionType: NotificationActionTypes.RESEND_MONTHLY_MARKETING_REPORT,
  requestStatusSelector: getResendMonthlyMarketingReportRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: ResendMonthlyMarketingReport
}));
const resendWeeklyProgressReport = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.resendEmail,
  initiatingActionType: NotificationActionTypes.RESEND_WEEKLY_PROGRESS_REPORT,
  requestStatusSelector: getResendWeeklyProgressReportRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: ResendWeeklyProgressReport
}));
const sendMonthlyMarketingReport = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.sendEmail,
  initiatingActionType: NotificationActionTypes.SEND_MONTHLY_MARKETING_REPORT,
  requestStatusSelector: getSendMonthlyMarketingReportRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: SendMonthlyMarketingReport
}));
const sendWeeklyProgressReport = requestEntity(new RequestEpicDescriptor({
  apiFunction: NotificationsAPI.sendEmail,
  initiatingActionType: NotificationActionTypes.SEND_WEEKLY_PROGRESS_REPORT,
  requestStatusSelector: getSendWeeklyProgressReportRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: SendWeeklyProgressReport
}));
export default combineEpics(fetchNotifications, updateWeeklyProgressReportSubscription, updateMonthlyMarketingReportSubscription, updateCalendarNotification, updateSuccessNotification, updateProjectsNotification, resendMonthlyMarketingReport, resendWeeklyProgressReport, updateLeadRevisitNotification, sendMonthlyMarketingReport, sendWeeklyProgressReport);